/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function(){   
  var nursery_collection_popup_close = sessionStorage.getItem("nursery-collection-popup");
  if(nursery_collection_popup_close != "open-once") {
    $('div#shopify-section-nursery-collection-popup').addClass('nursery-collection-popup-open');
  }
  $('.nursery-collection-popup-close').click(function(){
    sessionStorage.setItem("nursery-collection-popup", 'open-once');
    $('div#shopify-section-nursery-collection-popup').removeClass('nursery-collection-popup-open');
  });
  
  $('select.quantity-select').change(function(){
    var QuantityVal = $(this).val();
    if($(this).hasClass("bundle-quantity-select")){
      $(this).parents('.quantity-selector').find('input.Bundle_quantity_val').val(parseInt(QuantityVal) * 6);      
    }
  });
  
  $('.button-select-product').click(function(e){
    e.preventDefault();
    var formId = $(this).closest('form').attr('id');
    addItem(formId);
    $(this).parents('.ProductItem').find('.Product-Added-Check').show();
  });

  $('.QuantitySelector__Button').click(function(){
    console.log($(this).attr('class'))
    var Bundle_quantity_val =  parseInt($(this).parents('.QuantitySelector').find('.Bundle_quantity_val').val());
    var QuantitySelector__CurrentQuantity = parseInt($(this).parents('.QuantitySelector').find('.QuantitySelector__CurrentQuantity').val());
    if($(this).hasClass("Bundle_quantity_inc")){
      $('.Bundle_quantity_val').val(Bundle_quantity_val + 6)
      $('.QuantitySelector__CurrentQuantity').val(QuantitySelector__CurrentQuantity + 1)
      console.log(Bundle_quantity_val, QuantitySelector__CurrentQuantity)
    }
    if($(this).hasClass("Bundle_quantity_dec") && (Bundle_quantity_val > 6) && (QuantitySelector__CurrentQuantity > 1)){
      $('.Bundle_quantity_val').val(Bundle_quantity_val - 6)
      $('.QuantitySelector__CurrentQuantity').val(QuantitySelector__CurrentQuantity - 1)
      console.log(Bundle_quantity_val, QuantitySelector__CurrentQuantity)
    }
  })

  $('a.CartItem__Remove').click(function(e){
    $('.Product-Added-Check').hide();
  });
});

function addItem(form_id) {
  $.ajax({
    type: 'POST', 
    url: '/cart/add.js',
    dataType: 'json', 
    data: $('#'+form_id).serialize(),
    success: addToCartOk,
    error: addToCartFail
  });
}
function addToCartOk(product) { 
  console.log('Added..');
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
  $('#sidebar-cart').attr('aria-hidden', false);
  $('.PageOverlay').addClass('is-visible');
  $('button[data-drawer-id="sidebar-cart"], .PageOverlay.is-visible, .Close_Popup, .Continue_Shopping').click(function(){
    $('#sidebar-cart').attr('aria-hidden', true);
    $('.PageOverlay').removeClass('is-visible');
  });
} 
function addToCartFail(obj, status) { 
  console.log('Not Added..')
}
function CartSidebar(e) { 
  $('button[data-drawer-id="sidebar-cart"]').click();
}